<template>
	<AppRadioCardSelect v-model="selectedId" :options />
</template>

<script lang="ts" setup>
import { getCustomerSelectOptions } from "@/helpers/inventarisation/customers";
import type { InventarisationCustomers } from "@loanlink-nl/model-app";
import { computed } from "vue";

interface Props {
	customers: InventarisationCustomers;
}
const props = defineProps<Props>();
const selectedId = defineModel<string>();
const options = computed(() => getCustomerSelectOptions(props.customers));
</script>
